const map = {
	"./Badges_1.webp": "./src/assets/badges/Badges_1.webp",
	"./Badges_10.webp": "./src/assets/badges/Badges_10.webp",
	"./Badges_11.webp": "./src/assets/badges/Badges_11.webp",
	"./Badges_12.webp": "./src/assets/badges/Badges_12.webp",
	"./Badges_13.webp": "./src/assets/badges/Badges_13.webp",
	"./Badges_14.webp": "./src/assets/badges/Badges_14.webp",
	"./Badges_15.webp": "./src/assets/badges/Badges_15.webp",
	"./Badges_16.webp": "./src/assets/badges/Badges_16.webp",
	"./Badges_17.webp": "./src/assets/badges/Badges_17.webp",
	"./Badges_18.webp": "./src/assets/badges/Badges_18.webp",
	"./Badges_19.webp": "./src/assets/badges/Badges_19.webp",
	"./Badges_2.webp": "./src/assets/badges/Badges_2.webp",
	"./Badges_20.webp": "./src/assets/badges/Badges_20.webp",
	"./Badges_21.webp": "./src/assets/badges/Badges_21.webp",
	"./Badges_22.webp": "./src/assets/badges/Badges_22.webp",
	"./Badges_23.webp": "./src/assets/badges/Badges_23.webp",
	"./Badges_24.webp": "./src/assets/badges/Badges_24.webp",
	"./Badges_25.webp": "./src/assets/badges/Badges_25.webp",
	"./Badges_26.webp": "./src/assets/badges/Badges_26.webp",
	"./Badges_27.webp": "./src/assets/badges/Badges_27.webp",
	"./Badges_28.webp": "./src/assets/badges/Badges_28.webp",
	"./Badges_3.webp": "./src/assets/badges/Badges_3.webp",
	"./Badges_4.webp": "./src/assets/badges/Badges_4.webp",
	"./Badges_5.webp": "./src/assets/badges/Badges_5.webp",
	"./Badges_6.webp": "./src/assets/badges/Badges_6.webp",
	"./Badges_7.webp": "./src/assets/badges/Badges_7.webp",
	"./Badges_8.webp": "./src/assets/badges/Badges_8.webp",
	"./Badges_9.webp": "./src/assets/badges/Badges_9.webp"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/badges sync recursive ^\\.\\/Badges_.*\\.webp$";